import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); } catch { /* generic */ }
    setSent(true);
  };
  return (
    <Shell title="Recupera password">
      {sent ? (
        <p className="text-slate-600" data-testid="forgot-confirmation">Se l'email è registrata, riceverai un link per reimpostare la password.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Input type="email" placeholder="La tua email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12" data-testid="forgot-email" required />
          <Button type="submit" className="w-full h-12 font-bold text-white rounded-full" style={{ backgroundColor: "var(--sc-emerald)" }} data-testid="forgot-submit">Invia link</Button>
        </form>
      )}
      <div className="text-center mt-4"><Link to="/admin/login" className="text-sm text-emerald-800 hover:underline">← Torna al login</Link></div>
    </Shell>
  );
}

export function ResetPassword() {
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/reset-password", { token, password }); setDone(true); toast.success("Password aggiornata"); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <Shell title="Nuova password">
      {done ? (
        <div><p className="text-slate-600 mb-4">Password aggiornata con successo.</p><Link to="/admin/login"><Button className="w-full h-12 font-bold text-white rounded-full" style={{ backgroundColor: "var(--sc-emerald)" }}>Vai al login</Button></Link></div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Input type="password" placeholder="Nuova password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12" data-testid="reset-password" required />
          <Button type="submit" className="w-full h-12 font-bold text-white rounded-full" style={{ backgroundColor: "var(--sc-emerald)" }} data-testid="reset-submit">Reimposta password</Button>
        </form>
      )}
      <div className="text-center mt-4"><Link to="/admin/login" className="text-sm text-emerald-800 hover:underline">← Torna al login</Link></div>
    </Shell>
  );
}

const Shell = ({ title, children }) => (
  <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "linear-gradient(135deg,#8F0C3B,#EA155B)" }}>
    <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-8">
      <h1 className="text-2xl font-bold text-slate-900 mb-6 text-center" style={{ fontFamily: "Outfit" }}>{title}</h1>
      {children}
    </div>
  </div>
);
